var _mask, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 45,
    viewBox: "0 0 147 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_204_2655",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H139C143.418 0 147 3.58172 147 8V36.44C147 40.8583 143.418 44.44 139 44.44H8C3.58172 44.44 0 40.8583 0 36.44V8.00001Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V1H139V0V-1H8V0ZM147 8H146V36.44H147H148V8H147ZM139 44.44V43.44H8V44.44V45.44H139V44.44ZM0 36.44H1V8.00001H0H-1V36.44H0ZM8 44.44V43.44C4.13401 43.44 1 40.306 1 36.44H0H-1C-1 41.4106 3.02944 45.44 8 45.44V44.44ZM147 36.44H146C146 40.306 142.866 43.44 139 43.44V44.44V45.44C143.971 45.44 148 41.4105 148 36.44H147ZM139 0V1C142.866 1 146 4.13401 146 8H147H148C148 3.02944 143.971 -1 139 -1V0ZM8 0V-1C3.02944 -1 -1 3.02945 -1 8.00001H0H1C1 4.13402 4.13401 1 8 1V0Z",
    fill: "#545454",
    mask: "url(#path-1-inside-1_204_2655)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_2655)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_204_2655)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_204_2655)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_204_2655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 147,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.928 1H8.07138C4.16489 1 0.998047 4.16684 0.998047 8.07333V36.3667C0.998047 40.2732 4.16489 43.44 8.07138 43.44H138.928C142.835 43.44 146.001 40.2732 146.001 36.3667V8.07333C146.001 4.16684 142.835 1 138.928 1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_204_2655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.631 43.4822H6.36855C3.36106 43.4822 0.998047 41.0468 0.998047 38.1878V6.42093C0.998047 3.45603 3.46847 1.12646 6.36855 1.12646H140.631C143.638 1.12646 146.001 3.56192 146.001 6.42093V38.1878C146.001 41.0468 143.638 43.4822 140.631 43.4822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9103 11.8226C51.9103 12.6714 51.6956 13.4141 51.1585 13.9446C50.5141 14.5812 49.7622 14.8995 48.7955 14.8995C47.8288 14.8995 47.0769 14.5812 46.4325 13.9446C45.788 13.308 45.4658 12.5653 45.4658 11.6104C45.4658 10.6555 45.788 9.91276 46.4325 9.27618C47.0769 8.63958 47.8288 8.32129 48.7955 8.32129C49.2251 8.32129 49.6547 8.42739 50.0844 8.63959C50.5141 8.85179 50.8362 9.06399 51.0511 9.38229L50.5141 9.91276C50.0844 9.38229 49.5473 9.17009 48.7955 9.17009C48.151 9.17009 47.5066 9.38229 47.0769 9.91276C46.5399 10.3372 46.3251 10.9738 46.3251 11.7165C46.3251 12.4592 46.5399 13.0958 47.0769 13.5202C47.614 13.9446 48.151 14.2629 48.7955 14.2629C49.5473 14.2629 50.0844 14.0507 50.6215 13.5202C50.9437 13.2019 51.1585 12.7775 51.1585 12.247H48.7955V11.5043H51.9103C51.9103 11.5043 51.9103 11.7165 51.9103 11.8226Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8511 9.17043H53.951V11.1863H56.6362V11.929H53.951V13.9449H56.8511V14.7937H53.0918V8.42773H56.8511V9.17043Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3952 14.7937H59.5359V9.17043H57.71V8.42773H62.2212V9.17043H60.3952V14.7937Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3359 14.7937V8.42773H66.1952V14.7937H65.3359Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8483 14.7937H68.9891V9.17043H67.1631V8.42773H71.5669V9.17043H69.741V14.7937H69.8483Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0511 13.9446C79.4066 14.5812 78.6547 14.8995 77.6881 14.8995C76.7214 14.8995 75.9695 14.5812 75.3251 13.9446C74.6806 13.308 74.3584 12.5653 74.3584 11.6104C74.3584 10.6555 74.6806 9.91276 75.3251 9.27618C75.9695 8.63958 76.7214 8.32129 77.6881 8.32129C78.6547 8.32129 79.4066 8.63958 80.0511 9.27618C80.6956 9.91276 81.0178 10.6555 81.0178 11.6104C81.0178 12.5653 80.6956 13.308 80.0511 13.9446ZM75.9695 13.4141C76.3991 13.8385 77.0436 14.1568 77.6881 14.1568C78.3326 14.1568 78.977 13.9446 79.4066 13.4141C79.8362 12.9897 80.1585 12.3531 80.1585 11.6104C80.1585 10.8677 79.9437 10.2311 79.4066 9.80668C78.977 9.38228 78.3326 9.06399 77.6881 9.06399C77.0436 9.06399 76.3991 9.27618 75.9695 9.80668C75.5399 10.2311 75.2176 10.8677 75.2176 11.6104C75.2176 12.3531 75.4325 12.9897 75.9695 13.4141Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2002 14.7937V8.42773H83.1669L86.2818 13.4144V12.1412V8.42773H87.1411V14.7937H86.2818L82.9521 9.59483V10.868V14.7937H82.2002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.131141,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1442 24.1303C71.5663 24.1303 69.5256 26.0401 69.5256 28.6926C69.5256 31.239 71.5663 33.2549 74.1442 33.2549C76.7221 33.2549 78.7628 31.3451 78.7628 28.6926C78.7628 25.934 76.7221 24.1303 74.1442 24.1303ZM74.1442 31.3451C72.7479 31.3451 71.5663 30.178 71.5663 28.5865C71.5663 26.995 72.7479 25.8279 74.1442 25.8279C75.5406 25.8279 76.7221 26.8889 76.7221 28.5865C76.7221 30.178 75.5406 31.3451 74.1442 31.3451ZM64.1551 24.1303C61.5773 24.1303 59.5365 26.0401 59.5365 28.6926C59.5365 31.239 61.5773 33.2549 64.1551 33.2549C66.733 33.2549 68.7737 31.3451 68.7737 28.6926C68.7737 25.934 66.733 24.1303 64.1551 24.1303ZM64.1551 31.3451C62.7588 31.3451 61.5773 30.178 61.5773 28.5865C61.5773 26.995 62.7588 25.8279 64.1551 25.8279C65.5514 25.8279 66.733 26.8889 66.733 28.5865C66.733 30.178 65.5514 31.3451 64.1551 31.3451ZM52.2326 25.5096V27.4194H56.8512C56.7438 28.4804 56.3142 29.3292 55.7772 29.8597C55.1327 30.4963 54.0586 31.239 52.2326 31.239C49.3326 31.239 47.1843 29.0109 47.1843 26.1462C47.1843 23.2815 49.44 21.0534 52.2326 21.0534C53.7363 21.0534 54.9178 21.69 55.7772 22.4327L57.1734 21.0534C55.9919 19.9924 54.4882 19.1436 52.3401 19.1436C48.4732 19.1436 45.1436 22.3266 45.1436 26.1462C45.1436 29.9658 48.4732 33.1488 52.3401 33.1488C54.4882 33.1488 55.9919 32.5122 57.2809 31.1329C58.5698 29.8597 58.9994 28.056 58.9994 26.6767C58.9994 26.2523 58.9994 25.8279 58.892 25.5096H52.2326ZM100.997 26.995C100.567 25.934 99.4931 24.1303 97.1297 24.1303C94.7672 24.1303 92.8336 25.934 92.8336 28.6926C92.8336 31.239 94.7672 33.2549 97.3446 33.2549C99.3852 33.2549 100.674 31.9817 101.104 31.239L99.6001 30.178C99.0634 30.9207 98.4188 31.4512 97.3446 31.4512C96.2703 31.4512 95.6258 31.0268 95.0891 30.0719L101.212 27.5255L100.997 26.995ZM94.7672 28.4804C94.7672 26.7828 96.1633 25.8279 97.1297 25.8279C97.8821 25.8279 98.6337 26.2523 98.8485 26.7828L94.7672 28.4804ZM89.7186 32.8305H91.7593V19.568H89.7186V32.8305ZM86.4964 25.0852C85.9593 24.5547 85.1 24.0242 84.0259 24.0242C81.7703 24.0242 79.6222 26.0401 79.6222 28.5865C79.6222 31.1329 81.6629 33.0427 84.0259 33.0427C85.1 33.0427 85.9593 32.5122 86.389 31.9817H86.4964V32.6183C86.4964 34.3159 85.5296 35.2708 84.0259 35.2708C82.8444 35.2708 81.9851 34.422 81.7703 33.6793L80.0518 34.422C80.5888 35.5891 81.8778 37.0745 84.1334 37.0745C86.4964 37.0745 88.4297 35.6952 88.4297 32.4061V24.3425H86.4964V25.0852ZM84.1334 31.3451C82.737 31.3451 81.5555 30.178 81.5555 28.5865C81.5555 26.995 82.737 25.8279 84.1334 25.8279C85.5296 25.8279 86.6037 26.995 86.6037 28.5865C86.6037 30.178 85.5296 31.3451 84.1334 31.3451ZM110.341 19.568H105.508V32.8305H107.549V27.8438H110.341C112.597 27.8438 114.745 26.2523 114.745 23.7059C114.745 21.1595 112.597 19.568 110.341 19.568ZM110.449 25.934H107.549V21.3717H110.449C111.953 21.3717 112.812 22.6449 112.812 23.5998C112.704 24.7669 111.845 25.934 110.449 25.934ZM122.801 24.0242C121.298 24.0242 119.794 24.6608 119.256 26.0401L121.083 26.7828C121.512 26.0401 122.156 25.8279 122.908 25.8279C123.983 25.8279 124.949 26.4645 125.056 27.5255V27.6316C124.734 27.4194 123.875 27.1011 123.015 27.1011C121.083 27.1011 119.149 28.1621 119.149 30.0719C119.149 31.8756 120.76 33.0427 122.479 33.0427C123.875 33.0427 124.519 32.4061 125.056 31.7695H125.164V32.8305H127.098V27.7377C126.883 25.4035 125.056 24.0242 122.801 24.0242ZM122.586 31.3451C121.941 31.3451 120.975 31.0268 120.975 30.178C120.975 29.117 122.156 28.7987 123.123 28.7987C123.983 28.7987 124.412 29.0109 124.949 29.2231C124.734 30.4963 123.66 31.3451 122.586 31.3451ZM133.864 24.3425L131.609 30.0719H131.501L129.138 24.3425H126.99L130.534 32.4061L128.494 36.8623H130.534L136.013 24.3425H133.864ZM115.819 32.8305H117.86V19.568H115.819V32.8305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1689 8.95752C11.8466 9.27582 11.6318 9.80632 11.6318 10.4429V33.891C11.6318 34.5276 11.8466 35.0581 12.1689 35.3764L12.2763 35.4825L25.5951 22.3261V22.22V22.1139L12.1689 8.95752Z",
    fill: "url(#paint0_linear_204_2655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9986 26.7831L25.5947 22.433V22.2208V22.1147L29.9986 17.7646L30.106 17.8707L35.3691 20.8415C36.8728 21.6903 36.8728 23.0696 35.3691 23.9184L29.9986 26.7831Z",
    fill: "url(#paint1_linear_204_2655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1064 26.6764L25.5952 22.2202L12.1689 35.4827C12.706 36.0132 13.4579 36.0132 14.4245 35.5888L30.1064 26.6764Z",
    fill: "url(#paint2_linear_204_2655)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1064 17.7645L14.4245 8.95815C13.4579 8.42765 12.706 8.53375 12.1689 9.06425L25.5952 22.2207L30.1064 17.7645Z",
    fill: "url(#paint3_linear_204_2655)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.999 26.5698L14.4245 35.27C13.5652 35.8005 12.8134 35.6944 12.2763 35.27L12.1689 35.3761L12.2763 35.4822C12.8134 35.9066 13.5652 36.0127 14.4245 35.4822L29.999 26.5698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M12.169 35.2698C11.8467 34.9515 11.7393 34.4209 11.7393 33.7842V33.8903C11.7393 34.527 11.9541 35.0576 12.2764 35.3759V35.2698H12.169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M35.3695 23.5995L29.999 26.5703L30.1064 26.6764L35.3695 23.7056C36.1213 23.2812 36.4436 22.7507 36.4436 22.2202C36.4436 22.7507 36.014 23.1751 35.3695 23.5995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M14.4246 9.06327L35.3695 20.8404C36.0139 21.2648 36.4436 21.6892 36.4436 22.2197C36.4436 21.6892 36.1213 21.1587 35.3695 20.7343L14.4246 8.95717C12.9208 8.10837 11.7393 8.85107 11.7393 10.5487V10.6548C11.7393 8.95717 12.9208 8.21447 14.4246 9.06327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.63 1.93362C143.117 1.93362 145.141 3.93254 145.141 6.38949V38.2191C145.141 40.6761 143.117 42.675 140.63 42.675H6.36905C3.88176 42.675 1.85816 40.6761 1.85816 38.2191V6.38949C1.85816 3.93254 3.88176 1.93362 6.36905 1.93362H140.63ZM140.63 1.08398H6.36905C3.41465 1.08398 0.998047 3.47112 0.998047 6.38949V38.2191C0.998047 41.1375 3.41465 43.5246 6.36905 43.5246H140.63C143.585 43.5246 146.001 41.1375 146.001 38.2191V6.38949C146.001 3.47112 143.585 1.08398 140.63 1.08398Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_2655",
    x1: 24.4133,
    y1: 10.241,
    x2: 6.60848,
    y2: 28.2656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_2655",
    x1: 37.3394,
    y1: 22.2224,
    x2: 11.3495,
    y2: 22.2224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_204_2655",
    x1: 27.6649,
    y1: 24.6564,
    x2: 3.52022,
    y2: 49.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_204_2655",
    x1: 8.83632,
    y1: 1.1876,
    x2: 19.618,
    y2: 12.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 42.44,
    fill: "white",
    transform: "translate(1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_204_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 42.44,
    fill: "white",
    transform: "translate(1 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_204_2655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145.003,
    height: 42.44,
    fill: "white",
    transform: "translate(0.998047 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent4);
export default __webpack_public_path__ + "static/media/Component-4.6a0cf19198ffad6ebe7a8e36bf9dde77.svg";
export { ForwardRef as ReactComponent };